// @flow
import React from "react";
import styled from "styled-components";
import queryString from "query-string";
import { ResponsiveImage } from "./ResponsiveImage";

export const Img = styled.img`
  max-width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const FixedWidthResponsiveImage = styled(ResponsiveImage)`
  max-width: 100%;
  width: ${({ width }) => width}px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

type Props = {
  src: string,
  alt?: string,
};

export const EmbeddedImage = ({ src, ...rest }: Props) => {
  const { query } = queryString.parseUrl(src);
  if (query.w) {
    return <FixedWidthResponsiveImage {...rest} src={src} width={query.w} />;
  }
  return <Img {...rest} src={src} />;
};
